/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";

import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import StoryCard11 from "../../../molecules/story-card11";
import { getCollection } from "../../../helper/api";
// import { getRelatedStories } from "../../../helper/api";

import "./more-news.m.css";

const MoreNews = ({ story }) => {
  const [collection, setCollection] = useState([]);
  const ParentSectionUrl = story?.sections[0]["section-url"];
  const ParentCollectionSlug = story?.sections[0]?.collection?.slug;

  useEffect(() => {
    getCollection(ParentCollectionSlug && ParentCollectionSlug).then((collection) => setCollection(collection));
  }, []);

  return (
    <div styleName="wrapper">
      <div styleName="headline">
        <h1>ಇನ್ನಷ್ಟು ಸುದ್ದಿ</h1>
        {story && story.sections[0] && (
          <Link styleName="seemore" href={ParentSectionUrl && ParentSectionUrl}>
            ಇನ್ನಷ್ಟು
            <SvgIconHandler type="longrightarrow" />
          </Link>
        )}
      </div>
      <div styleName="stories">
        {collection &&
          collection.slice(0, 4).map((story, index) => (
            <div key={index}>
              <StoryCard11 story={story} />
            </div>
          ))}
      </div>
    </div>
  );
};

export default MoreNews;
